"use client";

import {
  NavigationItem,
  NavigationItemProps,
} from "@/app/(discover)/components/sidebar/navigation-item";
import { useCandidateCounts } from "@/hooks/data/use-candidate-counts";
import { isHiringSeasonDormant } from "@/lib/dormant-season/resolve";
import { useAuth } from "@/stores/use-auth";

export default function InvitesNavigationItem(props: NavigationItemProps) {
  const { user } = useAuth();
  const userId = user?.id;

  const invitationsDormant = isHiringSeasonDormant("invitations");
  const recommendedDormant = isHiringSeasonDormant("recommended");
  const countsDormant = invitationsDormant && recommendedDormant;

  const { data } = useCandidateCounts(userId, {
    enabled: !!userId && !countsDormant,
  });

  const invitationsCount = invitationsDormant ? 0 : data?.invitations_count;
  const recommendedCount = recommendedDormant
    ? 0
    : data?.teacher_recommendations_count;
  const totalCount = (invitationsCount ?? 0) + (recommendedCount ?? 0);

  return (
    <NavigationItem {...props}>
      {totalCount > 0 && (
        <span
          className="absolute -top-1 -right-1 bg-primary text-primary-foreground rounded-full min-w-[18px] h-[18px] px-1 flex items-center justify-center text-[10px] font-semibold leading-none"
          aria-label={`${totalCount} notifications`}
          data-testid="invites-count-badge"
        >
          {totalCount > 99 ? "99+" : totalCount}
        </span>
      )}
    </NavigationItem>
  );
}
